'use strict';

import ButtonAddToCart from './ButtonAddToCart';
import ButtonBuyNow from './ButtonBuyNow';

export default function ProductCartButtons({ nsProductId, nid, icon, name, unitPrice, quantity }) {

  return (
   <div className="button-wrapper">
     <ButtonAddToCart nsProductId={nsProductId} nid={nid} icon={icon} name={name} unitPrice={unitPrice} />
     <ButtonBuyNow nsProductId={nsProductId} nid={nid} icon={icon} name={name} unitPrice={unitPrice} />
   </div>
  )
}
